import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AllowableValue, DataType, Setting, SettingType } from 'src/app/core/settings/settings.service';

@Component({
  selector: 'setting-value-selector',
  templateUrl: './setting-value-selector.component.html',
  styleUrls: ['./setting-value-selector.component.scss'],
})
export class SettingValueSelectorComponent {
  @Output() settingAdded = new EventEmitter<Setting>();

  @Input()
  set setting(setting: SettingType) {
    this.currentValue = setting?.defaultValue
    this._setting = setting;
    this.unpinValue = false;
  }

  @Input()
  updatingSetting: boolean;

  get setting(): SettingType {
    return this._setting;
  }

  private _setting: SettingType;
  private booleanAllowableValues: AllowableValue[] = [
    { label: 'True', value: 'True' },
    { label: 'False', value: 'False' }
  ];

  unpinValue = false;
  currentValue: string;

  get isMultiSelect() {
    return this.allowableValues && this.allowableValues?.length > 0;
  }

  get allowableValues() {
    return this.setting?.dataType === DataType.boolean ? 
      this.booleanAllowableValues : this.setting?.allowableValues;
  }

  get fieldInputType() {
    // decimals are text because number inputs are mostly for integers
    return [DataType.int32, DataType.int64].includes(this.setting?.dataType) ? "number" : "text";
  }

  get buttonLabel() {
    return this.updatingSetting ? 'Update' : '+ Add';
  }

  onSelectOption(event) {
    this.currentValue = event.target['value'];
  }

  onAddSetting() {
    if (this.unpinValue) {
      this.settingAdded.emit({
        name: this.setting.name,
        value: null,
        displayValue: 'UNPIN'
      });
      return;
    }

    this.settingAdded.emit({
      name: this.setting.name,
      value: this.currentValue,
      displayValue: this.allowableValues?.find(v => v.value == this.currentValue)?.label ?? this.currentValue
    })
  }
}
